import { RootState } from '@/store'

export default function selectUserHasHome(state: RootState) {
  return !!state.homes.selectedHome
}
